// extracted by mini-css-extract-plugin
export default {"wrap":"NotFound_wrap__-N14p","icon":"NotFound_icon__yt0Rd","title":"NotFound_title__t-UU9","desc":"NotFound_desc__X--yO","actions":"NotFound_actions__ubLhT"};